<template>
<div>
  <div class="content">
    <van-form @submit="submitJsy">
      <van-cell-group inset>
      <ChoseVehicleUsage  :vehicleUsage="vehicleUsage.typecode"  @changeVehicleUsage="changeVehicleUsage"/>
        <div class="upload-box">
          <h2 class="upload-titile input-title-hq red-required">行驶证正页 <span class="image-show" @click="showImageDemo('zbfm')">（示例:如图）</span></h2>
          <div class="upload-xsz-box">
            <van-uploader :max-size="10 * 1024 * 1024" @oversize="onOversize" max-count="1" v-model="xsz_zb_fm_image" :before-read="beforeRead" :after-read="uploadXszZbFm" :before-delete="deleteXszZbFm"></van-uploader>
          </div>

          <h2 class="upload-titile input-title-hq red-required">行驶证副页<span class="image-show" @click="showImageDemo('fbzm')">（示例:如图）</span></h2>
          <div class="upload-xsz-box">
            <van-uploader :max-size="10 * 1024 * 1024" @oversize="onOversize" max-count="1" v-model="xsz_fb_zm_image" :before-read="beforeRead" :after-read="uploadXszFbZm" :before-delete="deleteXszFbZm"></van-uploader>
          </div>

          <h2 class="upload-titile input-title-hq red-required">行驶证副页反面<span class="image-show" @click="showImageDemo('fbfm')">（示例:如图）</span></h2>
          <div class="upload-xsz-box">
            <van-uploader :max-size="10 * 1024 * 1024" @oversize="onOversize" max-count="1" v-model="xsz_fb_fm_image" :before-read="beforeRead" :after-read="uploadXszFbFm" :before-delete="deleteXszFbFm"></van-uploader>
          </div>

          <h2 class="upload-titile input-title-hq red-required">行驶证机动车照片<span class="image-show" @click="showImageDemo('zbzm')">（示例:如图）</span></h2>
          <div class="upload-xsz-box">
            <van-uploader :max-size="10 * 1024 * 1024" @oversize="onOversize" max-count="1" v-model="xsz_zb_zm_image" :before-read="beforeRead" :after-read="uploadXszZbZm" :before-delete="deleteXszZbZm"></van-uploader>
          </div>

          <div class="jsz-front-info-box">
            <van-field v-model="chetouhao" name="chetouhao" required :value="chetouhao" :rules="[{ validator:validatorChetou, message: '请填写车头号' }]" placeholder="请输入">
              <template #label>
                <span class="input-left-label-hq">车头号</span>
              </template>
            </van-field>
            <van-field v-show="cheShow" v-model="chejiahao" name="chejiahao" :value="chejiahao" placeholder="请输入">
              <template #label>
                <span class="input-left-label-hq">车辆识别代号</span>
              </template>
            </van-field>

            <van-field v-model="sscd" name="sscd" required :value="sscd" :rules="[{ validator:validatorSscd, message: '请填写所属车队' }]" placeholder="请输入">
              <template #label>
                <span class="input-left-label-hq">所属车队</span>
              </template>
            </van-field>

            <van-field v-model="ctzl" name="ctzl" type="number" :value="ctzl">
              <template #extra>
                <div class="unit">KG</div>
              </template>
              <template #label>
                <span class="input-left-label-hq">车头质量(单车填写)</span>
              </template>
            </van-field>

            <van-field v-model="zhengbeizhiliang" name="zhengbeizhiliang" required :value="zhengbeizhiliang" type="number">
              <template #extra>
                <div class="unit">KG</div>
              </template>
              <template #label>
                <span class="input-left-label-hq">整备质量</span>
              </template>
            </van-field>

            <van-field v-model="zongzhiliang" name="zongzhiliang" type="number" :value="zongzhiliang">
              <template #extra>
                <div class="unit">KG</div>
              </template>
              <template #label>
                <span class="input-left-label-hq">总质量(单车填写)</span>
              </template>
            </van-field>

            <van-field v-model="xingshizhenghdzzl" name="xingshizhenghdzzl" type="number" :value="xingshizhenghdzzl" :rules="[{ validator:validatorXingshizhenghdzzl, message: '请填写行驶证核定载质量' }]">
              <template #extra>
                <div class="unit">吨</div>
              </template>
              <template #label>
                <span class="input-left-label-hq">行驶证核定载质量(单车填写)</span>
              </template>
            </van-field>
            <ChoseTime :timeVmodel="xszYxq" :timeName="xszYxq" :timeLabel="xszYxqLabel" @getYxq="getXszYxq" :timeValue="xingshizhengyxq" />
            
            

          </div>
        </div>
      </van-cell-group>

      <div class="itemBox" v-show="vehicleUsage.typecode == '2'">
        <van-cell-group inset>
          <div class="upload-box">
            <h2 class="upload-titile input-title-hq red-required">道路运输证正本正面图片 <span class="image-show" @click="showImageDemo('dlyszm')">（示例:如图）</span></h2>
            <div class="upload-dlysz-box">
              <van-uploader :max-size="10 * 1024 * 1024" @oversize="onOversize" max-count="1" v-model="dlys_zm_image" :before-read="beforeRead" :after-read="uploadDlysZm" :before-delete="deleteDlysZm"></van-uploader>
            </div>
            <h2 class="upload-titile input-title-hq title-extend red-required">道路运输证（待理证）正面图片<span>（车辆信息和经营范围2页拍在一起）<span class="image-show" @click="showImageDemo('dlczm')">（示例:如图）</span></span></h2>
            <div class="upload-dlysz-box">
              <van-uploader :max-size="10 * 1024 * 1024" @oversize="onOversize" max-count="1" v-model="dcl_zm_image" :before-read="beforeRead" :after-read="uploadDclZm" :before-delete="deleteDclZm"></van-uploader>
            </div>
            <h2 class="upload-titile input-title-hq title-extend red-required">道路运输证（待理证）反面图片 <span class="image-show" @click="showImageDemo('dlcfm')">（示例:如图）</span></h2>
            <div class="upload-dlysz-box">
              <van-uploader :max-size="10 * 1024 * 1024" @oversize="onOversize" max-count="1" v-model="dcl_fm_image" :before-read="beforeRead" :after-read="uploadDclFm" :before-delete="deleteDclFm"></van-uploader>
            </div>

            <ChoseTime :timeVmodel="dlysYxq" :timeName="dlysYxq" :timeLabel="dlysYxqLabel" @getYxq="getDlysYxq" :timeValue="daoluyszyxq" :timeRequire="false"/>
            <ChosePz :pzTitle="pzTitle" :isShowImportant="isShowImportant" @getChosePz="getDlysChosePz" :resultPz="pzArray" />

            <van-field v-model="beizhu" autosize name="beizhu" type="textarea" rows="3" maxlength="50" placeholder="请输入备注" :value="beizhu">
              <template #label>
                <span class="input-left-label-hq">备注</span>
              </template>
            </van-field>
          </div>
        </van-cell-group>
      </div>
      <div style="margin: 1rem;">
        <van-button round block type="info" native-type="submit" class="addBtn" @loading="loadingBtn" color="#316892">
          保存
        </van-button>
      </div>
    </van-form>
  </div>
  <Tabbar></Tabbar>
</div>
</template>
<script>
import api from "@/fetch/api"
import { Toast,Dialog,ImagePreview } from 'vant';
import ChoseTime from "../Public/choseTime.vue"
import ChosePz from "../Public/chosePz.vue"
import Compressor from 'compressorjs';
import Tabbar from '../Public/tabbarTpl.vue'
import ChoseVehicleUsage from '../Public/choseVehicleUsage.vue';
export default {
  components: {
    ChoseTime,
    ChosePz,
    Tabbar,
    ChoseVehicleUsage
  },
  data() {
    return {
      cheShow: false,
      xsz_zb_zm_image: [],
      xsz_zb_fm_image: [],
      xsz_fb_zm_image: [],
      xsz_fb_fm_image: [],
      xsz_zb_zm_url: "",
      xsz_zb_fm_url: "",
      xsz_fb_zm_url: "",
      xsz_fb_fm_url: "",
      zongzhiliang: 0, //总质量
      //行驶证正本反面
      chetouhao: "", //车头号
      sscd: "", //所属车队
      chejiahao: "", //车辆识别代号 行驶证正本反面
      //行驶证副本正面
      ctzl: 0, //车头质量
      xingshizhengyxq: "", //行驶证有效期
      zhengbeizhiliang: 0, //整备质量
      xingshizhenghdzzl: 0, //行驶证核定载质量
      xszYxq: "xingshizhengyxq",
      xszYxqLabel: "行驶证有效期",
      dlysYxq: "daoluyszyxq",
      dlysYxqLabel: "道路运输证有效期",
      pzTitle: "道路运输证经营范围",
      isShowImportant: true,
      dlys_zm_image: [],
      dcl_zm_image: [],
      dcl_fm_image: [],
      dlys_zm_url: "",
      dcl_zm_url: "",
      dcl_fm_url: "",
      daoluyszhao: "", //道路运输证号
      daoluyszjyfw: "", //道路运输证经营范围
      daoluyszyxq: "", //道路运输证有效期
      beizhu: "",
      loadingBtn: false,
      selectedData: [],
      pzArray: [],

      vehicleUsage:[],
      showUsagePicker:false,
      UsageColumns: [],
      timeRequire:true,
    };
  },
  created() {
    document.title = "新增车头信息";
  },
  methods: {
    
    changeVehicleUsage(data)
    {
       if(data)
      {
        this.vehicleUsage = data;
        if(this.vehicleUsage.typecode == '1'){
          this.timeRequire = false;
        }
        else{
          this.timeRequire = true;
        }
      }
    },
    beforeRead(file) {
      let quality = 0.6;
      if (file.size < 4 * 1024 * 1024) {
        quality = 0.9;
      } else if (file.size >= 4 * 1024 * 1024 && file.size < 8 * 1024 * 1024) {
        quality = 0.8;
      } else {
        quality = 0.6;
      }
      return new Promise((resolve) => {
        // compressorjs 默认开启 checkOrientation 选项
        // 会将图片修正为正确方向
        new Compressor(file, {
          quality: quality,
          success(result) {
            let newfile = new File([result], file.name, {
              type: file.type
            })
            resolve(newfile)
          },
          error(err) {
            console.log('图片压缩失败---->>>>>', err)
          }
        })

      });

    },
    onOversize(file) {
      console.log(file);
      Toast('文件大小不能超过 10Mb');
    },
    validatorChetou(val) {
      if (!val) {
        Toast.fail('请填写车头号');
        return false;
      }
      return val;
    },
    validatorChejia(val) {
      if (!val) {
        Toast.fail('请填写车辆识别代号');
        return false;
      }
      return val;
    },
    
    validatorSscd(val) {
      if (!val) {
        Toast.fail('请填写所属车队');
        return false;
      }
      return val;
    },
    validatorZbzl(val) {
      if (!val) {
        Toast.fail('请填写整备质量');
        return false;
      }
      return val;
    },
    validatorCtzl(val) {
      if (!val) {
        Toast.fail('请填写车头质量');
        return false;
      }
      return val;
    },
    validatorZongzhiliang(val) {
      if (!val) {
        Toast.fail('请填写总质量');
        return false;
      }
      return val;
    },
    validatorXingshizhenghdzzl(val) {
      if (!val) {
        Toast.fail('请填写行驶证核定载质量');
        return false;
      }
      return val;
    },
    validatorDaoluyszhao(val) {
      if (!val && this.vehicleUsage.typecode == '2') {
        Toast.fail('请填写道路运输证号');
        return false;
      }
      return val;
    },

    //提交表单
    submitJsy(values) {
      var that = this;
      var openid = that.$store.state.wx_info.openid;
      var xingshizhengzbfmurl = that.xsz_zb_fm_url ? that.xsz_zb_fm_url : "";
      var xingshizhengfbzmurl = that.xsz_fb_zm_url ? that.xsz_fb_zm_url : "";
      var xingshizhengfbfmurl = that.xsz_fb_fm_url ? that.xsz_fb_fm_url : "";
      var xingshizhengzbzmurl = that.xsz_zb_zm_url ? that.xsz_zb_zm_url : "";

      var daoluyszzbzmurl = that.dlys_zm_url ? that.dlys_zm_url : "";
      var daoluzmurl = that.dcl_zm_url ? that.dcl_zm_url : "";
      var daolufmurl = that.dcl_fm_url ? that.dcl_fm_url : "";

      if (!xingshizhengzbfmurl) {
        Toast.fail('请上传行驶证正页');
        return false;
      }
      if (!xingshizhengfbzmurl) {
        Toast.fail('请上传行驶证副页');
        return false;
      }
      if(!xingshizhengfbfmurl)
      {
        Toast.fail('请上传行驶证副页反面');
        return false;
      }
      if(!xingshizhengzbzmurl)
      {
        Toast.fail('请上传行驶证机动车照片');
        return false;
      }

      var ctzl = values.ctzl ? values.ctzl : 0;
      var zongzhiliang = values.zongzhiliang ? values.zongzhiliang : 0;
      var xingshizhenghdzzl = values.xingshizhenghdzzl ? values.xingshizhenghdzzl : 0;

      //蒸洗+作业
      if(that.vehicleUsage.typecode == '2')
      {
        if (!daoluyszzbzmurl) {
          Toast.fail('请上传道路运输证正本正面图片');
          return false;
        }

        if(!daoluzmurl && that.vehicleUsage.typecode == '2')
        {
          Toast.fail('请上传道路运输证（待理证）正面图片');
          return false;
        }
        if(!daolufmurl)
        {
          Toast.fail('请上传道路运输证（待理证）反面图片');
          return false;
        }

        var selectedData = that.$data.selectedData;
        if (selectedData.length == 0) {
          Toast.fail('请选择道路运输证经营范围');
          return false;
        }

        var daoluyszjyfw = "";
        for (var i = 0; i < selectedData.length; i++) {
          daoluyszjyfw += selectedData[i] + "|";
        }
        //去掉最后一个逗号(如果不需要去掉，就不用写)
        if (daoluyszjyfw.length > 0) {
          daoluyszjyfw = daoluyszjyfw.substr(0, daoluyszjyfw.length - 1);
        }
      }

      
      var zhengbeizhiliang = values.zhengbeizhiliang ? values.zhengbeizhiliang : 0;
      if (parseFloat(zhengbeizhiliang) <= 0) {
        Toast.fail('请填写正确的整备质量');
        return false;
      }

      
      that.$data.loadingBtn = true;
      var formData = JSON.stringify({
        openid: openid,
        chetouhao: values.chetouhao ? values.chetouhao : "",
        xingshizhengyxq: that.xingshizhengyxq ? that.xingshizhengyxq : "",
        sscd: values.sscd ? values.sscd : "",
        ctzl: ctzl,
        zhengbeizhiliang: zhengbeizhiliang,
        zongzhiliang: zongzhiliang,
        chejiahao: values.chejiahao ? values.chejiahao : "",
        xingshizhenghdzzl: xingshizhenghdzzl,
        xingshizhengzbzmurl: that.$data.xsz_zb_zm_url ? that.$data.xsz_zb_zm_url : "",
        xingshizhengzbfmurl: xingshizhengzbfmurl,
        xingshizhengfbzmurl: xingshizhengfbzmurl,
        xingshizhengfbfmurl: that.$data.xsz_fb_fm_url ? that.$data.xsz_fb_fm_url : "",
        daoluyszhao: values.daoluyszhao ? values.daoluyszhao : "",
        daoluyszjyfw: daoluyszjyfw,
        daoluyszyxq: that.daoluyszyxq ? that.daoluyszyxq : "",
        daoluyszzbzmurl: daoluyszzbzmurl,
        daoluyszdlzmurl: that.dcl_zm_url ? that.dcl_zm_url : "",
        daoluyszdlfmurl: that.dcl_fm_url ? that.dcl_fm_url : "",
        beizhu: values.beizhu ? values.beizhu : "",
        vehicleUsage:that.vehicleUsage.typecode,
      });

      api.beianChetou(formData).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          // 清掉首页车辆缓存，让回首页时重新拉最新行驶证有效期
          localStorage.removeItem('vehicleInfo');
          Dialog.alert({
            message: '信息保存成功',
          }).then(() => {
            that.$router.push({
              name: 'vehicle',
              params: {
                type: 0
              }
            })

          });
        } else {
          Dialog.alert({
            message: resData.message,
          }).then(() => {
            // on confirm
          });
        }
      }).catch(function(err) {
        console.log(err);
        that.$data.loadingBtn = false;
        Toast.fail('连接失败，请刷新页面');

      });
    },
    getXszYxq(xszYxq) {
      this.$data.xingshizhengyxq = xszYxq
    },
    getDlysYxq(xszYxq) {
      this.$data.daoluyszyxq = xszYxq
    },
    getDlysChosePz(selectedData) {
      this.$data.selectedData = selectedData;
      this.pzArray = selectedData;
    },
    mergeinfo(detail) {
      var that = this;
      const weburl = that.GLOBAL.weburl;
      that.chetouhao = detail.chetouhao ? detail.chetouhao : that.chetouhao;
      that.xingshizhengyxq = detail.xingshizhengyxq ? detail.xingshizhengyxq : that.xingshizhengyxq;
      that.sscd = detail.sscd ? detail.sscd : that.sscd;
      that.ctzl = detail.ctzl ? detail.ctzl : that.ctzl;
      that.zhengbeizhiliang = detail.zhengbeizhiliang ? detail.zhengbeizhiliang : that.zhengbeizhiliang;
      that.zongzhiliang = detail.zongzhiliang ? detail.zongzhiliang : that.zongzhiliang;
      that.chejiahao = detail.chejiahao ? detail.chejiahao : that.chejiahao;
      that.xingshizhenghdzzl = detail.xingshizhenghdzzl ? detail.xingshizhenghdzzl : that.xingshizhenghdzzl;
      that.daoluyszhao = detail.daoluyszhao ? detail.daoluyszhao : that.daoluyszhao;
      that.beizhu = detail.beizhu ? detail.beizhu : that.beizhu;
      that.daoluyszyxq = detail.daoluyszyxq ? detail.daoluyszyxq : that.daoluyszyxq;

      var daoluyszjyfw = that.daoluyszjyfw = detail.daoluyszjyfw;
      var pzArrayOld = daoluyszjyfw.split('|');

      let pzArrayNew = [];
      //var pzList = that.pzList;
      for (var i = 0; i < pzArrayOld.length; i++) {
        pzArrayNew.push(pzArrayOld[i]);
      }

      that.pzArray = pzArrayNew;
      that.selectedData = pzArrayNew;

      that.xsz_zb_zm_url = detail.xingshizhengzbzmurl ? detail.xingshizhengzbzmurl : that.xsz_zb_zm_url;
      that.xsz_zb_fm_url = detail.xingshizhengzbfmurl ? detail.xingshizhengzbfmurl : that.xsz_zb_fm_url;
      that.xsz_fb_zm_url = detail.xingshizhengfbzmurl ? detail.xingshizhengfbzmurl : that.xsz_fb_zm_url;
      that.xsz_fb_fm_url = detail.xingshizhengfbfmurl ? detail.xingshizhengfbfmurl : that.xsz_fb_fm_url;
      that.dlys_zm_url = detail.daoluyszzbzmurl ? detail.daoluyszzbzmurl : that.dlys_zm_url;
      that.dcl_zm_url = detail.daoluyszdlzmurl ? detail.daoluyszdlzmurl : that.dcl_zm_url;
      that.dcl_fm_url = detail.daoluyszdlfmurl ? detail.daoluyszdlfmurl : that.dcl_fm_url;

      that.xsz_zb_zm_image = detail.xingshizhengzbzmurl ? [{
        url: weburl + '/' + detail.xingshizhengzbzmurl
      }] : that.xsz_zb_zm_image;
      that.xsz_zb_fm_image = detail.xingshizhengzbfmurl ? [{
        url: weburl + '/' + detail.xingshizhengzbfmurl
      }] : that.xsz_zb_fm_image;
      that.xsz_fb_zm_image = detail.xingshizhengfbzmurl ? [{
        url: weburl + '/' + detail.xingshizhengfbzmurl
      }] : that.xsz_fb_zm_image;
      that.xsz_fb_fm_image = detail.xingshizhengfbfmurl ? [{
        url: weburl + '/' + detail.xingshizhengfbfmurl
      }] : that.xsz_fb_fm_image;
      that.dlys_zm_image = detail.daoluyszzbzmurl ? [{
        url: weburl + '/' + detail.daoluyszzbzmurl
      }] : that.dlys_zm_image;
      that.dcl_zm_image = detail.daoluyszdlzmurl ? [{
        url: weburl + '/' + detail.daoluyszdlzmurl
      }] : [];
      that.$data.dcl_fm_image = detail.daoluyszdlfmurl ? [{
        url: weburl + '/' + detail.daoluyszdlfmurl
      }] : that.$data.dcl_fm_image;
    },
    //上传行驶证正本正面
    uploadXszZbZm(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      var that = this;
      const type = 'xsz_zb_zm'
      const weburl = that.GLOBAL.weburl;
      let formData = new FormData();
      formData.append("uploadpics", file.file);
      formData.append("ctid", '');
      api.uploadXsz(type, formData).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          var imageData = resData.data;
          that.$data.xsz_zb_zm_url = imageData.xingshizhengzbzmurl ? imageData.xingshizhengzbzmurl : "";
          that.$data.xsz_zb_zm_image = imageData.xingshizhengzbzmurl ? [{
            url: weburl + '/' + imageData.xingshizhengzbzmurl
          }] : [];
        } else {
          setTimeout(() => {
            file.status = 'failed';
            file.message = '上传失败';
          }, 1000);
          Toast.fail(resData.message);
        }
      }).catch(function(err) {
        console.log(err);
        Toast.fail('上传图片失败，请重新再试');
        setTimeout(() => {
          file.status = 'failed';
          file.message = '上传失败';
        }, 1000);
      });
    },
    //上传行驶证正本反面 正页
    uploadXszZbFm(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      var that = this;
      const type = 'xsz_zb_fm'
      const weburl = that.GLOBAL.weburl;
      let formData = new FormData();
      formData.append("uploadpics", file.file);
      formData.append("ctid", '');
      api.uploadXsz(type, formData).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          var imageData = resData.data;
          that.$data.xsz_zb_fm_url = imageData.xingshizhengzbfmurl ? imageData.xingshizhengzbfmurl : "";
          that.$data.xsz_zb_fm_image = imageData.xingshizhengzbfmurl ? [{
            url: weburl + '/' + imageData.xingshizhengzbfmurl
          }] : [];

          if (imageData.bpmStatus === "3") {
            var detail = imageData;
            that.mergeinfo(detail);
          } else {
            that.$data.xsz_zb_fm_url = imageData.xingshizhengzbfmurl ? imageData.xingshizhengzbfmurl : "";
            that.$data.chetouhao = imageData.chetouhao ? imageData.chetouhao : that.$data.chetouhao; //车头号
            that.$data.sscd = imageData.sscd ? imageData.sscd : that.$data.sscd; //所属车队
            that.$data.chejiahao = imageData.chejiahao ? imageData.chejiahao : that.$data.chejiahao; //车辆识别代号
          }
        } else {
          setTimeout(() => {
            file.status = 'failed';
            file.message = '上传失败';
          }, 1000);
          Toast.fail(resData.message);
        }
      }).catch(function(err) {
        console.log(err);
        Toast.fail('上传图片失败，请重新再试');
        setTimeout(() => {
          file.status = 'failed';
          file.message = '上传失败';
        }, 1000);
      });
    },
    //上传行驶证副本正面 副页
    uploadXszFbZm(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      var that = this;
      const type = 'xsz_fb_zm'
      const weburl = that.GLOBAL.weburl;
      let formData = new FormData();
      formData.append("uploadpics", file.file);
      formData.append("ctid", '');

      api.uploadXsz(type, formData).then(function(res) {

        var resData = JSON.parse(res);

        if (resData.respCode == "0") {

          var imageData = resData.data;
          that.$data.xsz_fb_zm_url = imageData.xingshizhengfbzmurl ? imageData.xingshizhengfbzmurl : "";
          that.$data.xsz_fb_zm_image = imageData.xingshizhengfbzmurl ? [{
            url: weburl + '/' + imageData.xingshizhengfbzmurl
          }] : [];

          if (imageData.bpmStatus === "3") {
            var detail = imageData;
            that.mergeinfo(detail);
          } else {
            that.$data.ctzl = imageData.ctzl ? imageData.ctzl : that.$data.ctzl; //车头质量
            that.$data.xingshizhengyxq = imageData.xingshizhengyxq ? imageData.xingshizhengyxq : that.$data.xingshizhengyxq; //行驶证有效期
            that.$data.zhengbeizhiliang = imageData.zhengbeizhiliang ? imageData.zhengbeizhiliang : that.$data.zhengbeizhiliang; //整备质量
            that.$data.zongzhiliang = imageData.zongzhiliang ? imageData.zongzhiliang : that.$data.zongzhiliang; //总质量
            that.$data.xingshizhenghdzzl = imageData.xingshizhenghdzzl ? imageData.xingshizhenghdzzl : that.$data.xingshizhenghdzzl; //行驶证核定载质量
          }


        } else {
          setTimeout(() => {
            file.status = 'failed';
            file.message = '上传失败';
          }, 1000);
          Toast.fail(resData.message);
        }
      }).catch(function(err) {
        console.log(err);
        Toast.fail('上传图片失败，请重新再试');
        setTimeout(() => {
          file.status = 'failed';
          file.message = '上传失败';
        }, 1000);
      });
    },
    //上传行驶证副本反面
    uploadXszFbFm(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      var that = this;
      const type = 'xsz_fb_fm'
      const weburl = that.GLOBAL.weburl;
      let formData = new FormData();
      formData.append("uploadpics", file.file);
      formData.append("ctid", '');
      api.uploadXsz(type, formData).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          var imageData = resData.data;
          that.$data.xsz_fb_fm_url = imageData.xingshizhengfbfmurl ? imageData.xingshizhengfbfmurl : "";
          that.$data.xsz_fb_fm_image = imageData.xingshizhengfbfmurl ? [{
            url: weburl + '/' + imageData.xingshizhengfbfmurl
          }] : [];
        } else {
          setTimeout(() => {
            file.status = 'failed';
            file.message = '上传失败';
          }, 1000);
          Toast.fail(resData.message);
        }

      }).catch(function(err) {
        console.log(err);
        Toast.fail('上传图片失败，请重新再试');
        setTimeout(() => {
          file.status = 'failed';
          file.message = '上传失败';
        }, 1000);
      });
    },
    //道路运输证正本正面图片
    uploadDlysZm(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      var that = this;
      const weburl = that.GLOBAL.weburl;
      let formData = new FormData();
      formData.append("uploadpics", file.file);
      formData.append("ctid", '');
      api.uploadDlys(formData).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          var imageData = resData.data;
          that.$data.dlys_zm_url = imageData.daoluyszzbzmurl ? imageData.daoluyszzbzmurl : "";
          that.$data.dlys_zm_image = imageData.daoluyszzbzmurl ? [{
            url: weburl + '/' + imageData.daoluyszzbzmurl
          }] : [];
          if(imageData.daoluyszyxq) that.daoluyszyxq = imageData.daoluyszyxq;
          if(that.chetouhao != imageData.chetouhao && that.chetouhao)
          {
            Toast.fail("证件车辆与登记车头号不符合");
          }
        }
        else if(resData.respCode == "-1" && resData.data != null)
        {
          var imageData2 = resData.data;
          that.dlys_zm_url = imageData2.daoluyszzbzmurl ? imageData2.daoluyszzbzmurl : "";
          that.dlys_zm_image = imageData2.daoluyszzbzmurl ? [{
            url: weburl + '/' + imageData2.daoluyszzbzmurl
          }] : [];
        } 
        else {
          setTimeout(() => {
            file.status = 'failed';
            file.message = '上传失败';
          }, 1000);
          Toast.fail(resData.message);
        }
      }).catch(function(err) {
        console.log(err);
        Toast.fail('上传图片失败，请重新再试');
        setTimeout(() => {
          file.status = 'failed';
          file.message = '上传失败';
        }, 1000);
      });

    },
    uploadDclZm(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      var that = this;
      const weburl = that.GLOBAL.weburl;
      let formData = new FormData();
      formData.append("uploadpics", file.file);
      formData.append("ctid", '');
      const type = 'dcl_zm';
      api.uploadDcl(type, formData).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          var imageData = resData.data;
          that.$data.dcl_zm_url = imageData.daoluyszdlzmurl ? imageData.daoluyszdlzmurl : "";
          that.$data.dcl_zm_image = imageData.daoluyszdlzmurl ? [{
            url: weburl + '/' + imageData.daoluyszdlzmurl
          }] : [];
          if(imageData.daoluyszyxq) that.daoluyszyxq = imageData.daoluyszyxq;
          if(that.chetouhao != imageData.chetouhao && that.chetouhao)
          {
            Toast.fail("证件车辆与登记车头号不符合");
          }
        }
        else if(resData.respCode == "-1" && resData.data != null)
        {
          var imageData2 = resData.data;
          that.dlys_zm_url = imageData2.daoluyszzbzmurl ? imageData2.daoluyszzbzmurl : "";
          that.dlys_zm_image = imageData2.daoluyszzbzmurl ? [{
            url: weburl + '/' + imageData2.daoluyszzbzmurl
          }] : [];
        } 
        else {
          setTimeout(() => {
            file.status = 'failed';
            file.message = '上传失败';
          }, 1000);
          Toast.fail(resData.message);
        }
      }).catch(function(err) {
        console.log(err);
        Toast.fail('上传图片失败，请重新再试');
        setTimeout(() => {
          file.status = 'failed';
          file.message = '上传失败';
        }, 1000);
      });
    },
    uploadDclFm(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      var that = this;
      const weburl = that.GLOBAL.weburl;
      let formData = new FormData();
      formData.append("uploadpics", file.file);
      formData.append("ctid", '');
      const type = 'dcl_fm';
      api.uploadDcl(type, formData).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          var imageData = resData.data;
          that.$data.dcl_fm_url = imageData.daoluyszdlfmurl ? imageData.daoluyszdlfmurl : "";
          that.$data.dcl_fm_image = imageData.daoluyszdlfmurl ? [{
            url: weburl + '/' + imageData.daoluyszdlfmurl
          }] : [];
          if(imageData.daoluyszyxq) that.daoluyszyxq = imageData.daoluyszyxq;
          if(that.chetouhao != imageData.chetouhao && that.chetouhao)
          {
            Toast.fail("证件车辆与登记车头号不符合");
          }
        }
        else if(resData.respCode == "-1" && resData.data != null)
        {
          var imageData2 = resData.data;
          that.dlys_zm_url = imageData2.daoluyszzbzmurl ? imageData2.daoluyszzbzmurl : "";
          that.dlys_zm_image = imageData2.daoluyszzbzmurl ? [{
            url: weburl + '/' + imageData2.daoluyszzbzmurl
          }] : [];
        } 
        else {
          setTimeout(() => {
            file.status = 'failed';
            file.message = '上传失败';
          }, 1000);
          Toast.fail(resData.message);
        }
      }).catch(function(err) {
        console.log(err);
        Toast.fail('上传图片失败，请重新再试');
        setTimeout(() => {
          file.status = 'failed';
          file.message = '上传失败';
        }, 1000);
      });

    },
    deleteXszZbFm() {
      this.$data.xsz_zb_fm_url = "";
      this.$data.xsz_zb_fm_image = [];
    },
    deleteXszFbZm() {
      this.$data.xsz_fb_zm_url = "";
      this.$data.xsz_fb_zm_image = [];
    },
    deleteXszFbFm() {
      this.$data.xsz_fb_fm_url = "";
      this.$data.xsz_fb_fm_image = [];
    },
    deleteXszZbZm() {
      this.$data.xsz_zb_zm_url = "";
      this.$data.xsz_zb_zm_image = [];
    },
    deleteDlysZm() {
      this.$data.dlys_zm_url = "";
      this.$data.dlys_zm_image = [];
    },
    deleteDclZm() {
      this.$data.dcl_zm_url = "";
      this.$data.dcl_zm_image = [];
    },
    deleteDclFm() {
      this.$data.dcl_fm_url = "";
      this.$data.dcl_fm_image = [];
    },
    showImageDemo(type) {
      let images = [];
      switch (type) {
        case 'zbzm':
          images = [require('@/assets/images/ctsl.png')];
          break;
        case 'zbfm':
          images = [require('@/assets/images/zbfm.png')];
          break;
        case 'fbzm':
          images = [require('@/assets/images/fbzm.png')];
          break;
        case 'fbfm':
          images = [require('@/assets/images/fbfm.png')];
          break;
        case 'dlyszm':
          images = [require('@/assets/images/ctdlyszm.png')];
          break;
        case 'dlczm':
          images = [require('@/assets/images/ctdlczm.jpg')];
          break;
        case 'dlcfm':
          images = [require('@/assets/images/dlcfm.jpg')];
          break;

      }

      ImagePreview({
        images: images,
        closeable: true,
      });
    },
  }
};
</script>

<style lang="scss" scoped>
.content {
    margin-top: 1rem;
    margin-bottom: 3.75rem;
    padding-bottom: env(safe-area-inset-bottom);
}

.itemBox {
    margin-top: 1rem;
}

.upload-box {
    //border-top: 1px solid #ececec;
    background: #fff;
    margin-top: 0.625rem;
    .upload-titile {
        padding: 0.675rem 1rem;
        .image-show {
            margin-left: 0.5rem;
            color: #2440b3;
        }
    }
    .title-extend {
        line-height: 1.5;
    }
    .upload-xsz-box {
        margin-left: 1rem;
    }
    .upload-dlysz-box {
        margin-left: 1rem;
    }

}

.pz-box {
    .van-checkbox-group {
        margin-left: 1rem;
    }
}

.unit {
    padding-left: 0.2rem;
    color: #969799;
}

.red-required::before{
  position: absolute;
  left: 8px;
  color: #ee0a24;
  font-size: 14px;
  content: '*';
}
</style>
